import "./NewsFeatures.scss";
import DateInput from "@/components/Common/DateInput/DateInput.vue";
import NewsFeaturesList from "@/components/News/NewsFeaturesList/NewsFeaturesList.vue";
import InfoDialog from "@/components/Common/InfoDialog/InfoDialog.vue";
import { confirmWarningConfig } from "@/configuration/confirmConfigurations";
import { getTokenHeader } from "@/helpers/commonHelper";
import axios from "axios";
import { orderBy, sortBy } from "lodash";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

export default {
  name: "NewsFeatures",
  components: { DateInput, NewsFeaturesList, InfoDialog },

  data: () => ({
    dialog: false,
    headers: [
      { text: "Titel", value: "title" },
      { text: "Merkmalsgruppe", value: "feature_group_id" },
      { text: "Erstellt", value: "create_date" },
      { text: "Geändert", value: "change_date" },
      { text: "Sortierung Backend", value: "sort" },
      {
        text: "Aktionen",
        value: "actions",
        sortable: false,
        align: "center",
        width: "5%"
      }
    ],
    editedItem: {
      title: ""
    },
    defaultItem: {
      title: ""
    },
    editLoading: false,

    valueTypes: [
      { id: "", title: "kein Wert" },
      { id: "string", title: "String" },
      { id: "integer", title: "Ganzzahl" },
      { id: "float", title: "Gleitkommazahl" }
    ],
    permissions: [
      { id: "all", title: "Alle" },
      { id: "news_admin", title: "News Administrator" },
      { id: "admin", title: "OYA Admin" }
    ]
  }),
  async mounted() {
    if (!this.isAdmin && !this.isNewsAdmin) {
      return await this.$router.push(`/news/`);
    }
    await this.loadFeatureGroups();
    await this.loadFeatures();
  },
  computed: {
    formTitle() {
      return this.editedItem.isNew ? "Merkmale anlegen" : "Merkmale bearbeiten";
    },
    currentPrincipal() {
      return this.$store.state.selectedPrincipal.id;
    },
    principals() {
      return this.$store.state.principals ?? [{}];
    },
    isAdmin() {
      return this.$store.state.currentUser?.scopes.includes("role:admin");
    },
    isNewsAdmin() {
      return this.$store.state.currentUser?.scopes.includes("role:news_admin");
    },
    isValid() {
      return this.editedItem?.title?.length;
    },
    featureGroups() {
      return this.$store.state.newsFeatureGroups.filter(item =>
        !this.isAdmin ? item.owner === this.currentPrincipal : true
      );
    },
    globalFeatureGroups() {
      return this.$store.state.newsFeatureGroups.filter(
        item => !item.owner?.length
      );
    },
    ownFeatureGroups() {
      return this.$store.state.newsFeatureGroups.filter(
        item => item.owner === this.currentPrincipal
      );
    },
    globalFeatures() {
      return this.$store.state.newsFeatures.filter(item =>
        this.globalFeatureGroups.find(fg => fg._id === item.feature_group_id)
      );
    },
    ownFeatures() {
      return this.$store.state.newsFeatures.filter(item =>
        this.ownFeatureGroups.find(fg => fg._id === item.feature_group_id)
      );
    }
  },
  methods: {
    async createError(error) {
      this.$store.dispatch("createError", error);
    },
    async createSuccess(successMessage) {
      this.$store.dispatch("createSuccess", successMessage);
    },
    async loadFeatures() {
      try {
        await this.$store.dispatch("getFeatures", {
          principal_id: this.currentPrincipal
        });
      } catch (err) {
        this.$emit("createError", err);
      }
    },
    async loadFeatureGroups() {
      try {
        await this.$store.dispatch("getFeatureGroups", {
          principal_id: this.currentPrincipal
        });
      } catch (err) {
        this.$emit("createError", err);
      }
    },
    createItem() {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedItem.isNew = true;
      this.editedItem.principal_id = this.currentPrincipal;
      this.editedItem.appdinx_channel_id = null;
      this.dialog = true;
      this.$refs?.editForm?.reset();
    },
    editItem(item) {
      this.editedItem = Object.assign({}, item);
      this.editedItem.isNew = false;
      this.dialog = true;
    },
    async deleteItem(item) {
      const confirmed = await this.$confirm(
        `Sind Sie sicher, dass Sie 
        <br>"${item.title}" löschen wollen?`,
        confirmWarningConfig
      );
      if (confirmed) {
        try {
          await this.deleteFeature(item);
        } catch (err) {
          this.createError(err);
          return;
        }
        this.editedItem = Object.assign({}, item);

        this.loadFeatures().then(this.closeDelete);
      }
    },
    async deleteFeature(item) {
      const title = item.title;
      const params = {
        principal_id: this.currentPrincipal
      };
      const headers = getTokenHeader(),
        res = await axios.delete(
          `${env.news_api_client_url}feature/${item._id}`,
          {
            headers,
            params
          }
        );
      if (res.status === 200) {
        this.createSuccess(title + " gelöscht!");
      } else {
        this.createError({ ...res, text: item.title + " nicht gelöscht!" });
      }
    },
    async afterSave(close) {
      await this.loadFeatures();
      if (close) {
        this.close();
      }
      this.createSuccess("Erfolgreich gespeichert!");
    },
    close() {
      this.editedItem = { ...this.defaultItem };
      this.dialog = false;

      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
      });
    },
    closeDelete() {
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
      });
    },
    async save(close) {
      if (this.$refs.editForm.validate()) {
        let success = false;
        this.loadingStatus(true);
        try {
          success = this.editedItem.isNew
            ? await this.createFeature()
            : await this.updateFeature();
          if (success) {
            this.afterSave(close);
          }
        } catch (ex) {
          this.createError(ex);
        }
        this.loadingStatus(false);
      } else {
        this.createError({
          text: "Nicht gespeichert! Bitte alle Pflichtfelder überprüfen!"
        });
      }
    },
    async updateFeature() {
      const headers = getTokenHeader(),
        res = await axios.put(
          `${env.news_api_client_url}feature`,
          this.editedItem,
          { headers }
        );
      return res.status === 200;
    },
    async createFeature() {
      const headers = getTokenHeader(),
        res = await axios.post(
          `${env.news_api_client_url}feature`,
          this.editedItem,
          { headers }
        );
      this.editedItem.isNew = false;
      this.editedItem._id = res.data._id;
      return res.status === 200;
    },
    loadingStatus(status) {
      this.editLoading = status;
    }
  }
};
